import { render, staticRenderFns } from "./BookingFormPrice.vue?vue&type=template&id=e01cc774"
import script from "./BookingFormPrice.vue?vue&type=script&lang=js"
export * from "./BookingFormPrice.vue?vue&type=script&lang=js"
import style0 from "./BookingFormPrice.vue?vue&type=style&index=0&id=e01cc774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports